module.exports = __webpack_public_path__ + "static-appopensalud/img/primesalud_blue.97aa48e.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/primesalud_blue.svg
// module id = 1056
// module chunks = 117